import widgetApi from "../api/widget";

export default function initWidgets() {
  document.querySelectorAll("div[data-task-id]").forEach(function (elem) {
    widgetApi.task(elem.attributes["data-task-id"].value).then((result) => {
      elem.outerHTML = result;
    });
  });
  document.querySelectorAll("div[data-widget-id]").forEach(function (elem) {
    widgetApi.module(elem.attributes["data-widget-id"].value).then((result) => {
      elem.outerHTML = result;
    });
  });
}
